import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

interface propsType {
  toggleModal: () => void
  selectedWork: any
  onSave: (data: WorkUpdate) => Promise<void>
}

export type WorkUpdate = {
  companyName: string
  role: string
  duration: {
    endYear: string
    startYear: string
  }
  companyContactName: string
  officialEmail: string
  officialPhoneNumber: string
}

const schema = yup.object().shape({
  companyName: yup.string().required('Field is required'),
  role: yup.string().required('Field is required'),
  duration: yup.object().shape({
    startYear: yup.string().required('Field is required'),

    endYear: yup.string().required('Field is required'),
  }),
  companyContactName: yup.string().required('Field is required'),
  officialEmail: yup.string().required('Field is required'),
  officialPhoneNumber: yup.string().required('Field is required'),
})

const WorkUpdate: FC<propsType> = ({ toggleModal, selectedWork, onSave }) => {
  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<WorkUpdate>({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (selectedWork) {
      reset({
        companyName: selectedWork.companyName,
        role: selectedWork.role,
        duration: {
          startYear: selectedWork.startYear,
          endYear: selectedWork.endYear,
        },
        companyContactName: selectedWork.companyContactName,
        officialEmail: selectedWork.officialEmail,
        officialPhoneNumber: selectedWork.officialPhoneNumber,
      })
    } else {
      reset({
        companyName: '',
        role: '',
        duration: {
          endYear: undefined,
          startYear: undefined,
        },
        companyContactName: '',
        officialEmail: '',
        officialPhoneNumber: '',
      })
    }
  }, [selectedWork, reset])

  const submitNewUserInformation = handleSubmit(async (data) => {
    setRequest(true)
    try {
      await onSave(data)

      toggleModal()
    } finally {
      setRequest(false)
    }
  })

  return (
    <div className='bank-update'>
      <form onSubmit={submitNewUserInformation}>
        {/* School */}
        <div className='form-group'>
          <label htmlFor='companyNameExp'>Company Name</label>
          <input
            type='text'
            id='companyNameExp'
            className={`form-control ${errors.companyName ? 'is-invalid' : ''}`}
            {...register('companyName', {})}
          />
          {errors.companyName && (
            <div className='invalid-feedback'>{errors.companyName.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='roleExp'>Role</label>
          <input
            type='text'
            id='roleExp'
            className={`form-control ${errors.role ? 'is-invalid' : ''}`}
            {...register('role', {})}
          />
          {errors.role && <div className='invalid-feedback'>{errors.role.message}</div>}
        </div>

        {/* <div className='form-group mt-3'>
          <label htmlFor='yearExp'>Year</label>
          <input
            type='number'
            id='yearExp'
            className={`form-control ${errors.yearExp ? 'is-invalid' : ''}`}
            {...register('yearExp', {})}
          />
          {errors.yearExp && <div className='invalid-feedback'>{errors.yearExp.message}</div>}
        </div> */}

        <div className='form-group mt-3'>
          <label>Year</label>

          <div className='row g-2'>
            <div className='col-6'>
              <input
                step='1'
                min='1900'
                max={new Date().getFullYear()}
                type='text'
                placeholder='Start Year'
                className={`form-control ${errors.duration?.startYear ? 'is-invalid' : ''}`}
                {...register('duration.startYear', {
                  valueAsNumber: true,
                })}
              />

              {errors.duration?.startYear && (
                <div className='invalid-feedback'>{errors.duration.startYear.message}</div>
              )}
            </div>

            <div className='col-6'>
              <input
                step='1'
                min='1900'
                max={new Date().getFullYear()}
                type='text'
                placeholder='End Year'
                className={`form-control ${errors.duration?.endYear ? 'is-invalid' : ''}`}
                {...register('duration.endYear', {
                  valueAsNumber: true,
                })}
              />

              {errors.duration?.endYear && (
                <div className='invalid-feedback'>{errors.duration.endYear.message}</div>
              )}
            </div>
          </div>
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='ownerExp'>HR/Owner Name</label>
          <input
            type='text'
            id='ownerExp'
            className={`form-control ${errors.companyContactName ? 'is-invalid' : ''}`}
            {...register('companyContactName', {})}
          />
          {errors.companyContactName && (
            <div className='invalid-feedback'>{errors.companyContactName.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='emailExp'>Official Email</label>
          <input
            type='text'
            id='emailExp'
            className={`form-control ${errors.officialEmail ? 'is-invalid' : ''}`}
            {...register('officialEmail', {})}
          />
          {errors.officialEmail && (
            <div className='invalid-feedback'>{errors.officialEmail.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='phoneExp'>Official Phone Number</label>
          <input
            type='text'
            id='phoneExp'
            className={`form-control ${errors.officialPhoneNumber ? 'is-invalid' : ''}`}
            {...register('officialPhoneNumber', {})}
          />
          {errors.officialPhoneNumber && (
            <div className='invalid-feedback'>{errors.officialPhoneNumber.message}</div>
          )}
        </div>

        <div className='form-group mt-4'>
          <button disabled={request} className='btn btn-default-2 w-100' type='submit'>
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default WorkUpdate